import { render, staticRenderFns } from "./ScanAndCard.vue?vue&type=template&id=193a9d5d&scoped=true&"
import script from "./ScanAndCard.vue?vue&type=script&lang=js&"
export * from "./ScanAndCard.vue?vue&type=script&lang=js&"
import style0 from "./ScanAndCard.vue?vue&type=style&index=0&id=193a9d5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a9d5d",
  null
  
)

export default component.exports